import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { fetchComments } from "src/actions/community/commentsActions";
import { queryParams } from "src/helpers/UrlHelpers";

import Pagination from "src/componets/Pagination";
import Card from "src/componets/Card";
import CommentsList from "../../Comments/_partials/_List";
import useGoToComment from "src/hooks/useGoToComment";

const LIMIT = 20;

const _Comments = ({ userId }: { userId: number | undefined }) => {
  const dispatch = useAppDispatch();
  const isRedirect = useGoToComment({ limit: LIMIT });
  const [searchParams]  = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const count = useAppSelector(state => state.community.comments.count);

  useEffect(() => {
    if (!userId || isRedirect) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      user_id: userId
    };

    dispatch(fetchComments(params));
  }, [userId, currentPage, dispatch, isRedirect]);

  return (
    <Card>
      <h4 className='v-content-title'>Comments</h4>

      {isRedirect ?
        <div>Redirecting...</div> :
        <CommentsList />
      }

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _Comments;
